import $ from 'jquery';
import TomSelect from 'tom-select/dist/js/tom-select.complete.min.js';
import { _x } from '@wordpress/i18n';

let fieldsAreInitialized = false;

function initSelects() {
  const selects = document.querySelectorAll(
    'select.custom-select, .gform_wrapper select, .variations_form select, .woocommerce-ordering select'
  );

  if (0 < selects.length) {
    selects.forEach((select) => {
      if (!select.tomselect) {
        new TomSelect(select, {
          create: false,
          maxItems: 1,
          controlInput: null,
        });
      }
    });
  }
}

function changeSingleFileUpload(formID) {
  // select right file uploads
  let singleFileUploads;
  if (formID) {
    const form = document.querySelector('form[data-formid="' + formID + '"]');
    singleFileUploads = form.querySelectorAll('.gfield--fileupload-single');
  } else {
    singleFileUploads = document.querySelectorAll('.gfield--fileupload-single');
  }
  // single file uploads
  if (0 < singleFileUploads.length) {
    singleFileUploads.forEach(function (fileUpload) {
      const uploadContainer = fileUpload.querySelector(
        '.ginput_container_fileupload'
      );
      const input = fileUpload.querySelector('input[type="file"]');
      const label = fileUpload.querySelector('.gfield_label');
      const noFileLabel = _x('No file uploaded', 'file upload', 'vtx');

      // create elements
      const wrapper = document.createElement('div');
      const removeBtn = document.createElement('button');
      const uploadBtn = document.createElement('p');
      const filePlaceholder = document.createElement('p');

      // add classes
      wrapper.classList.add('fake-upload');
      filePlaceholder.classList.add('fake-upload__file-placeholder');
      uploadBtn.classList.add('fake-upload__upload-btn');
      uploadBtn.classList.add('btn');
      removeBtn.classList.add('fake-upload__remove-btn');

      // add text contents
      removeBtn.innerHTML =
        '<span class="sr-only">' +
        _x('Clear file', 'file upload', 'vtx') +
        '</span><span class="icon-close"></span>';
      uploadBtn.textContent = label.textContent;
      filePlaceholder.textContent = input.value ? input.value : noFileLabel;

      // extra attributes
      removeBtn.setAttribute('type', 'button');

      // append elements
      wrapper.appendChild(uploadBtn);
      wrapper.appendChild(filePlaceholder);
      wrapper.appendChild(removeBtn);
      uploadContainer.appendChild(wrapper);
      //label.after(wrapper);

      input.addEventListener('change', function () {
        if (input.value) {
          const filename = input.value.replace(/^C:\\fakepath\\/i, '');
          filePlaceholder.textContent = filename;
          removeBtn.classList.add('visible');
        } else {
          filePlaceholder.textContent = noFileLabel;
          removeBtn.classList.remove('visible');
        }
      });

      input.addEventListener('focus', function () {
        wrapper.classList.add('has-focus');
      });

      input.addEventListener('blur', function () {
        wrapper.classList.remove('has-focus');
      });

      fileUpload.addEventListener('onmouseenter', function () {
        wrapper.classList.add('has-hover');
      });

      fileUpload.addEventListener('onmouseout', function () {
        wrapper.classList.remove('has-hover');
      });

      removeBtn.addEventListener('click', function () {
        input.value = '';
        filePlaceholder.textContent = noFileLabel;
        removeBtn.classList.remove('visible');
      });
    });
  }
}

function changeMultipleFileUpload(formID) {
  let multiFileUploads;
  if (formID) {
    const form = document.querySelector('form[data-formid="' + formID + '"]');
    multiFileUploads = form.querySelectorAll('.gfield--fileupload-multiple');
  } else {
    multiFileUploads = document.querySelectorAll(
      '.gfield--fileupload-multiple'
    );
  }
  if (0 < multiFileUploads.length) {
    multiFileUploads.forEach(function (fileUpload) {
      fileUpload.querySelector('.gform_drop_instructions').textContent = _x(
        'Drag and drop file to upload',
        'drag and drop instruction',
        'vtx'
      );
    });
  }
}

$(document).on('gform_post_render', function (e, formID) {
  fieldsAreInitialized = true;
  changeMultipleFileUpload(formID);
  changeSingleFileUpload(formID);
  initSelects();
});

// ON READY
window.addEventListener('load', function () {
  if (!fieldsAreInitialized) {
    changeMultipleFileUpload();
    changeSingleFileUpload();
    initSelects();
  }
});
